import TableCellCompanie from '../../Components/Includes/Table/TableCellCompanie'

export const companie = {
  id: "companie",
  sort: true,
  padding: true,
  label: "Entreprise",
  component: TableCellCompanie
}
